import { uuidv7 } from "uuidv7";

const DEVICE_ID_KEY = "automint_device_id";

/**
 * Get or create a unique device ID
 * Stored in localStorage for persistence across tabs/sessions
 */
export function getOrCreateDeviceId(): string {
	// Check localStorage first
	if (typeof window !== "undefined") {
		let deviceId = localStorage.getItem(DEVICE_ID_KEY);

		if (!deviceId) {
			// Generate new UUID v7
			deviceId = uuidv7();
			localStorage.setItem(DEVICE_ID_KEY, deviceId);
		}

		return deviceId;
	}

	return uuidv7();
}

// Sync function
export function syncDeviceId(newDeviceId: string): void {
	if (typeof window !== "undefined") {
		localStorage.setItem(DEVICE_ID_KEY, newDeviceId);

		// Update deviceId cookie
		document.cookie = `deviceId=${newDeviceId}; path=/; max-age=${365 * 24 * 60 * 60}; SameSite=Lax`;

		// DELETE GuestAuthorization cookie (will regenerate with correct g1 when needed)
		document.cookie = "GuestAuthorization=; path=/; max-age=0";
	}
}
